import type {
	OrganizationChartDesignTokens,
	OrganizationChartTokenSections,
} from '@openng/optimus-ui-themes/types/organizationchart';

export const nodeToggleButton: OrganizationChartTokenSections.NodeToggleButton = {
	borderRadius: '{organizationchart.node.toggle.button.size} / 2',
};

export default {
	nodeToggleButton,
} satisfies OrganizationChartDesignTokens;
